import { ref, onMounted, onUnmounted, watch } from 'vue'

export function useMobileMenu() {
  const isMenuOpen = ref<boolean>(false)
  const activeSubmenu = ref<string | null>(null)
  const containerRef = ref<HTMLDivElement | null>(null)

  const handleMenuToggle = () => {
    isMenuOpen.value = !isMenuOpen.value
    if (isMenuOpen.value === false) {
      activeSubmenu.value = null
    }
  }

  const handleSubmenuToggle = (menuKey: string, hasSubmenu: boolean) => {
    console.log('🔄 [useMobileMenu] handleSubmenuToggle called:', { menuKey, hasSubmenu, currentActive: activeSubmenu.value })
    if (hasSubmenu) {
      const newValue = activeSubmenu.value === menuKey ? null : menuKey
      console.log('🔄 [useMobileMenu] Setting activeSubmenu to:', newValue)
      activeSubmenu.value = newValue
    } else {
      activeSubmenu.value = null
      isMenuOpen.value = false
    }
  }

  const closeMenu = () => {
    isMenuOpen.value = false
    activeSubmenu.value = null
  }

  // Gestion des clics en dehors du menu et du scroll
  const handleDocumentClick = (event: MouseEvent) => {
    const target = event.target as Node
    // Vérifier si le clic est dans le container ou dans le drawer (qui est téléporté)
    const isInContainer = containerRef.value && containerRef.value.contains(target)
    const isInDrawer = (target as Element)?.closest('.mobile-menu-drawer') !== null
    const isInOverlay = (target as Element)?.classList.contains('overlay-backdrop') || false
    
    console.log('🖱️ [useMobileMenu] Document click:', { isInContainer, isInDrawer, isInOverlay, target: (target as Element)?.className })
    
    // Ne fermer que si le clic est vraiment en dehors (pas dans le container, pas dans le drawer, mais peut être dans l'overlay)
    if (!isInContainer && !isInDrawer && !isInOverlay) {
      console.log('🖱️ [useMobileMenu] Closing menu - click outside')
      closeMenu()
    }
  }

  // Watch pour isMenuOpen et gérer le scroll et les listeners
  watch(isMenuOpen, (newValue) => {
    if (newValue) {
      document.addEventListener('mousedown', handleDocumentClick)
      document.body.style.overflow = 'hidden'
    } else {
      document.removeEventListener('mousedown', handleDocumentClick)
      document.body.style.overflow = 'unset'
    }
  })

  onUnmounted(() => {
    document.removeEventListener('mousedown', handleDocumentClick)
    document.body.style.overflow = 'unset'
  })

  return {
    isMenuOpen,
    activeSubmenu,
    containerRef,
    handleMenuToggle,
    handleSubmenuToggle,
    closeMenu,
    setIsMenuOpen: (value: boolean) => {
      isMenuOpen.value = value
    }
  }
}
